import React from "react";
import Chip from "@material-ui/core/Chip";
import TranslatedText from "./TranslatedText";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import { eventStatusColorMap } from "../common/statuses";
import myRestClient from "../common/restClient";

const styles = theme => ({
    root: {
        display: "flex",
        justifyContent: "center",
        flexWrap: "wrap"
    },
    chip: {
        margin: theme.spacing.unit
    }
});

class StatusChip extends React.Component {
    static propTypes = {
        record: PropTypes.object
    };

    state = { color: "", description: "", name: "" };

    componentDidMount = () => {
        const { record, source } = this.props;
        this.setState({
            color: eventStatusColorMap[record[source]],
            description: "",
            name: ""
        });
        if (record[source]) {
            myRestClient("GET_ONE_BY_PARAMETERS", "event_types", {
                name: record[source]
            }).then(
                result => {
                    if (result && result.data[0]) {
                        this.setState({
                            color: result.data[0].status_color,
                            description: result.data[0].description,
                            name: result.data[0].name
                        });
                    }
                },
                error => {
                    console.log(error);
                }
            );
        }
    };

    render() {
        const { record, source } = this.props;
        return (
            <Chip
                className={this.props.classes.chip}
                label={
                    <span style={{ marginTop: 2 }}>
                        {this.state.description ? (
                            <TranslatedText
                                resource_name={`${this.state.description}`}
                            />
                        ) : record && record[source] ? (
                            <TranslatedText
                                resource_name={`${this.props.translationRoot}.${record[source]}`}
                            />
                        ) : (
                            ""
                        )}
                    </span>
                }
                //TO-DO move the style to CSS files
                style={{
                    color: "white",
                    border: `1px solid ${this.state.color}`,
                    background: `${this.state.color}`,
                    height: "auto",
                    width: "100%"
                }}
                variant="outlined"
            />
        );
    }
}

export default withStyles(styles)(StatusChip);



// WEBPACK FOOTER //
// ./src/components/StatusChip.js